import { render } from "./views/DonantProfile.html?vue&type=template&id=b8c9cae8&external"
import script from "./DonantProfile.vue?vue&type=script&lang=js"
export * from "./DonantProfile.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__